import React from 'react'

import { useInView } from 'react-cool-inview'

import { bool, number, string, func } from 'prop-types'

import { NOOP } from 'Utils/stableDefaults'

import OneTimeOption from './OneTimeOption/OneTimeOption'
import SubscriptionOption from './SubscriptionOption/SubscriptionOption'

function SubscriptionPurchase({
  subscriptionPricePerModel,
  subscriptionPerModelLabel,
  subscriptionFromPriceLabel,
  subscriptionDownloadsPerMonth,
  subscriptionCatalogValue,
  productPrice,
  productOriginalPrice = null,
  hasDiscount = false,
  selectedOption,
  onOptionChange: handleOptionChange,
  onImpression = NOOP,
}) {
  // Fires the impression once the plan selector is at least 50% visible. The
  // selector only renders when the item is in the subscription and the user has
  // no active subscription, so the event represents exactly that acquisition case.
  const { observe } = useInView({
    threshold: 0.5,
    onEnter: ({ unobserve }) => {
      unobserve()
      onImpression()
    },
  })

  return (
    <div ref={observe} className="subscription-purchase">
      <SubscriptionOption
        selected={selectedOption === 'subscription'}
        onSelect={() => handleOptionChange('subscription')}
        pricePerModel={subscriptionPricePerModel}
        perModelLabel={subscriptionPerModelLabel}
        fromLabel={subscriptionFromPriceLabel}
        downloadsPerMonth={subscriptionDownloadsPerMonth}
        catalogValue={subscriptionCatalogValue}
      />

      <OneTimeOption
        selected={selectedOption === 'onetime'}
        onSelect={() => handleOptionChange('onetime')}
        price={productPrice}
        originalPrice={productOriginalPrice}
        hasDiscount={hasDiscount}
      />
    </div>
  )
}

SubscriptionPurchase.propTypes = {
  subscriptionPricePerModel: string.isRequired,
  subscriptionPerModelLabel: string.isRequired,
  subscriptionFromPriceLabel: string.isRequired,
  subscriptionDownloadsPerMonth: number.isRequired,
  subscriptionCatalogValue: string.isRequired,
  productPrice: string.isRequired,
  productOriginalPrice: string,
  hasDiscount: bool,
  selectedOption: string.isRequired,
  onOptionChange: func.isRequired,
  onImpression: func,
}

export default SubscriptionPurchase
